var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select"},[_c('div',{staticClass:"select-value"},[_vm._v(_vm._s(_vm.input.placeholder)+" "),_c('i',{staticClass:"fa-solid fa-chevron-down"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }